import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
  .account-summary {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    max-width: 376px;
    margin: auto;
    gap: 12px;
  }
  :global(body){
    overflow-x:hidden;
  }
  .account-name {
    margin: auto;
    padding-bottom: 12px;
  }

  .avatar {
    display:flex;
    align-items: center;
  }
  .avatar-container.loading {
    box-shadow: none;
  }

  .avatar-container {
    margin: auto;
    width: 119.97px;
    height: 119.97px;
    border: none;
    border-radius: 128px;
    box-shadow: rgb(131 64 223) 0px 0px 110px 1px;
  }

  .avatar-container.plus {
    box-shadow: #549d86 0 0 110px 1px;
  }

  .avatar-container.premier_sports {
    box-shadow: #ffff00 0 0 110px 1px;
  }

  .account-details {
    display: flex;
    gap: 2px;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .account-name {
    flex-basis: 100%;
  }

  .account-name p {
    text-transform: capitalize;
    font-size: 22px;
    font-weight: 600;
    line-height: 27.65px;
    text-align: center;
    color: ${colors.primaryText};
  }

  .account-menu, .membership-menu, .sign-out-delete-menu {
    border-radius: 8px;
    background-color: ${colors.elevatedBg};
    padding: 0px;
  }
  .AccountSummary{
    padding: 8px 8px 55px 8px;
    height: 100%;
  }
  .menu-title {
    font-family: Source Sans Pro;
    font-size: 18px;
    font-weight: 600;
    line-height: 22.63px;
  }
  .menu-title.loading{
    width: 75%;
    height: 30px;
    background: linear-gradient(90deg, #313131 25%, #484848 50%, #313131 75%);
    background-size: 200% 100%;
    animation: wave 3.5s linear infinite;
    border-radius: 8px;
  }
  .menu-item {
    list-style: none;
    align-content: center;
    border-radius: 8px;
  }



  .menu-item:hover{
        background-color: ${colors.ctvBg};
  }
  .menu-link-button {
    background: none;
    color: ${colors.hoverRed};
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    display: block;
    width: 100%;
    text-align: left;
  }

  .menu-link {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
.menu-link.loading,
.menu-link-button.loading {
  height: 49px;
  background: linear-gradient(90deg, #313131 25%, #484848 50%, #313131 75%);
  background-size: 200% 100%;
  animation: wave 3.5s linear infinite;
  border-radius: 8px;
  justify-content: end;
}
@keyframes wave {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
  .menu-link,
  .menu-link-button {
    padding: 14px 24px 14px 24px;
  }
`
